import React, { useReducer, useState } from "react";
import { Divider, Grid, Stack } from "@mui/material";
import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import { ContainedButton } from "../../components/600/MyButtons";
import { useEffect } from "react";
import { MyDropdown } from "../../components/600/MyDropdown";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { MyTab } from "../../components/600/MyTabs";
import {
  MyBarChartCard,
  MyPieChartCard,
  MyTextCard,
} from "../../components/600/MyCards";
import { LoadCoverage } from "../../components/600/loadCoverage";
import reducer from "../../components/600/BatchReport/reducers/reducer";
import { initialState } from "../../components/600/BatchReport/initialStates/initialState";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import styled from "@emotion/styled";

const muiCache = createCache({
  key: "mui",
  prepend: true,
});
const options = {
  filterType: "checkbox",
};
const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
  background: theme.palette.background.default,
}));

const BatchReport = () => {
  const [reportState, reportDispatch] = useReducer(reducer, initialState);
  const [visualize, setVisualize] = useState(false);
  const api = useAxiosPrivate();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    if (reportState.action === 1) {
      api
        .get("batchReport/", {
          signal: controller.signal,
        })
        .then((res) => {
          console.log(res.data);
          isMounted && reportDispatch({ type: "load", payload: res.data });
        })
        .catch((err) => console.log("Error:", err));
    } else if (reportState.action === 2) {
      api
        .get("batchReport/filter", {
          params: {
            semester: reportState.selectedSemester,
            term: reportState.selectedTerm,
            department: reportState.selectedDepartment,
            college: reportState.selectedCollege,
            tab: reportState.tab,
          },
          signal: controller.signal,
        })
        .then((res) => {
          console.log(res.data);
          isMounted && reportDispatch({ type: "load", payload: res.data });
        })
        .catch((err) => console.log("Error:", err));
    } else if (reportState.action === 3) {
      api
        .get("batchReport/tab", {
          params: {
            semester: reportState.selectedSemester,
            term: reportState.selectedTerm,
            department: reportState.selectedDepartment,
            college: reportState.selectedCollege,
            tab: reportState.tab,
          },
        })
        .then((res) => {
          console.log(res.data);
          isMounted && reportDispatch({ type: "load", payload: res.data });
        })
        .catch((err) => console.log("Error:", err));
    }
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reportState?.action]);

  const handleCollegeFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: {
        selectedCollege: e.target.value,
        selectedDepartment: "All",
        action: 2,
      },
    });
  };
  const handleDepartmentFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: { selectedDepartment: e.target.value, action: 2 },
    });
  };
  const handleSemesterFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: { selectedSemester: e.target.value, action: 2 },
    });
  };
  const handleTermFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: {
        selectedTerm: e.target.value,
        selectedSemester: reportState.semesters
          .filter((semester) => semester.academic_year === e.target.value)
          .map((term) => term.semester_term)
          .sort()[0],
        action: 2,
      },
    });
  };
  function handleTabChange(value) {
    reportDispatch({
      type: "changeTab",
      payload: {
        tab: value,
        action: 3,
        tableData: [],
        tableColumn: [],
        tableHeader: "",
      },
    });
  }

  return (
    <Box sx={{ m: 2 }}>
      {/* Filters */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "right", sm: "center" }}
        justifyContent="flex-end"
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{
          m: 1,
          md: {
            backgroundColor: "#ff0",
          },
        }}>
        {/* Semester filter */}
        {reportState.showColleges && (
          <MyDropdown
            inputs={{
              name: "College",
              defaultValue: reportState.selectedCollege,
              handleChange: handleCollegeFilter,
              id: "Semester_filter",
              values: reportState.colleges,
              disable: false,
            }}
          />
        )}
        {reportState.showDepartments && (
          <MyDropdown
            inputs={{
              name: "Department",
              defaultValue: reportState.selectedDepartment,
              handleChange: handleDepartmentFilter,
              id: "Semester_filter",
              values: reportState.departments,
              disable: false,
            }}
          />
        )}
        <MyDropdown
          inputs={{
            name: "Semester",
            defaultValue: reportState.selectedSemester,
            handleChange: handleSemesterFilter,
            id: "Semester_filter",
            values: [
              ...new Set(
                reportState.semesters
                  .filter(
                    (semester) =>
                      semester.academic_year === reportState.selectedTerm
                  )
                  .map((term) => term.semester_term)
                  .sort()
              ),
            ],
            disable: false,
          }}
        />

        {/* Term Filter */}
        <MyDropdown
          inputs={{
            name: "Academic Year",
            defaultValue: `${reportState.selectedTerm}`,
            handleChange: handleTermFilter,
            id: "Term_filter",
            values: [
              ...new Set(
                reportState.semesters.map((semester) => semester.academic_year)
              ),
            ],
            disable: false,
          }}
        />

        {/* Charts Toggle Button */}
        <ContainedButton
          variant="contained"
          color="secondary"
          onClick={() => setVisualize(!visualize)}>
          {visualize ? "Visualize" : "Report"}
        </ContainedButton>
      </Stack>
      {/* Visualize */}
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ m: 1, mb: 2 }}>
        <MyTextCard
          inputs={{
            value: reportState.students,
            title: "Students Enrolled",
            size: 3,
          }}
        />
        <MyTextCard
          inputs={{
            value: reportState.groups,
            title: "Groups Formulated",
            size: 3,
          }}
        />
        {visualize && (
          <MyBarChartCard
            inputs={{
              title: "Admission",
              option1: "Regular",
              value1: reportState.regular,
              option2: "Extension",
              value2: reportState.extension,
            }}
          />
        )}
        {visualize && (
          <MyBarChartCard
            inputs={{
              title: "Program",
              option1: "Undergraduate",
              value1: reportState.undergraduate,
              option2: "Postgraduate",
              value2: reportState.postgraduate,
            }}
          />
        )}
        {!visualize && (
          <MyPieChartCard
            inputs={{
              mydata: {
                name: "Admission",
                option1: "Regular",
                option2: "Extension",
                value1: reportState.regular,
                value2: reportState.extension,
              },
            }}
          />
        )}
        {!visualize && (
          <MyPieChartCard
            inputs={{
              mydata: {
                name: "Program",
                option1: "Undergraduate",
                option2: "Postgraduate",
                value1: reportState.undergraduate,
                value2: reportState.postgraduate,
              },
            }}
          />
        )}
      </Grid>
      {/* Load Coverage
      <LoadCoverage
        inputs={{
          load: reportState.load,
          disable:
            reportState.selectedSemester ===
              reportState.currentTerm.semester_term &&
            reportState.selectedTerm === reportState.currentTerm.academic_year
              ? false
              : true,
        }}
      /> */}
      {/* Tabs */}
      <Box sx={{ width: "100%" }}>
        <Box>
          <MyTab
            inputs={{
              tabs: [
                { label: "Batches", tab: 0 },
                { label: "Sections", tab: 1 },
                { label: "Groups", tab: 2 },
              ],
              defaultTab: reportState.tab,
              handleTabChange,
            }}
          />
        </Box>
      </Box>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={reportState.tableHeader}
          data={reportState.tableData}
          columns={reportState.tableColumn}
          options={options}
        />
      </CacheProvider>
    </Box>
  );
};

export default BatchReport;
